import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { Popover, Spin } from 'antd';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CustomerResource from "../customers/api/CustomerResource";
import { axiosErrorHandler } from "../../../../swzutils";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons/faInfoCircle";
import ValOrDash from "../../components/ValOrDash";
const DebtorNotePopover = (props) => {
    const [loading, setLoading] = useState(false);
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [note, setNote] = useState(undefined);
    useEffect(() => {
        if (popoverOpen && props.customerId && note === undefined) {
            setLoading(true);
            CustomerResource.getDebtorNote(props.customerId, (debtorNote) => setNote(debtorNote), axiosErrorHandler, () => setLoading(false));
        }
    }, [popoverOpen, props.customerId]);
    return (_jsxs(Popover, { onOpenChange: setPopoverOpen, destroyOnHidden: true, title: !loading && note?.debtor?.name
            ? note.debtor?.name
            : null, content: _jsx(Spin, { spinning: loading, children: _jsx("pre", { style: {
                    maxWidth: '480px',
                    textWrap: 'wrap'
                }, children: _jsx(ValOrDash, { val: note?.note }) }) }), children: [_jsx(FontAwesomeIcon, { icon: faInfoCircle, fixedWidth: false, size: "lg" }), props.children] }));
};
export default DebtorNotePopover;
